import * as Yup from "yup";

export const notificationsBirthdaySchema = Yup.object().shape({
  type: Yup.string()
    .required("Tipo é obrigatório")
    .oneOf(["birthday", "pre_birthday"]),
  days_before: Yup.number()
    .nullable()
    .transform((v) => (v === "" ? null : v))
    .when(
      ["type"],
      (
        values: unknown[],
        schema: Yup.NumberSchema<number | null | undefined>,
      ) => {
        const type = values?.[0] as string | undefined;
        return type === "pre_birthday"
          ? schema
              .required("Dias antes é obrigatório para pre_birthday")
              .min(0, "Dias antes deve ser >= 0")
          : schema.nullable();
      },
    ),
  title: Yup.string()
    .transform((v) => (typeof v === "string" ? v.trim() : v))
    .required("Título é obrigatório"),
  body: Yup.string()
    .transform((v) => (typeof v === "string" ? v.trim() : v))
    .required("Mensagem é obrigatória")
    .max(500, "Mensagem deve ter no máximo 500 caracteres"),
  active: Yup.boolean().required(),
});
